module.exports = __webpack_public_path__ + "static/media/fitbit-aria.01906922.webp";